import React from "react";
import "./Toggle.scss";

interface ToggleOption<T> {
  label: string;
  value: T;
}

interface ToggleProps<T> {
  options: [ToggleOption<T>, ToggleOption<T>];
  value: T;
  onChange: (value: T) => void;
}

function Toggle<T>({ options, value, onChange }: ToggleProps<T>) {
  return (
    <div className="tcsp-toggle">
      {options.map((option, index) => {
        const selected = value === option.value;
        return (
          <button
            key={index}
            type="button"
            onClick={() => onChange(option.value)}
            className={`tcsp-toggle__option${selected ? " tcsp-toggle__option--selected" : ""}`}
            aria-pressed={selected}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}

export default Toggle;
